import { createFileRoute } from '@tanstack/react-router'
import { requireAuth } from '@/common/routes/requireAuth'
import QuickStartController from '@/pages/organizations/detail/quick-start'

export const Route = createFileRoute(
  '/app/organizations/$organizationId/quick-start',
)({
  beforeLoad: ({ context }) => {
    requireAuth(context)
  },
  component: QuickStartController,
})
